/* Afroyla FALL CLEARANCE claim-deal LP — "We did the math" flip cards: tap/click flips a card to reveal its
 * clearance price (front = regular price + "Tap to see the clearance price", back = was/now/save + a "Claim
 * this deal" CTA). Each card flips independently and can flip back. The flip trigger is a div[role=button]
 * (not a real <button>, since the back face nests a real <a> CTA — buttons can't legally contain another
 * interactive element), so this module also adds the Enter/Space keyboard handling a native button gets for
 * free. The CTA's own click handler stops propagation so clicking it scrolls to the form instead of flipping
 * the card back. Also pauses the hero product marquee under reduced motion. Needs window.AFD (core, loaded
 * first).
 */
(function () {
  var A = window.AFD;
  if (!A) return;
  var root = A.root;

  root.querySelectorAll('[data-afd-card]').forEach(function (card) {
    var btn = card.querySelector('[data-afd-card-btn]');
    if (!btn) return;
    function toggle() {
      var flipped = card.classList.toggle('is-flipped');
      btn.setAttribute('aria-pressed', String(flipped));
    }
    btn.addEventListener('click', toggle);
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); toggle(); }
    });
  });

  root.querySelectorAll('[data-afd-card-claim]').forEach(function (cta) {
    cta.addEventListener('click', function (e) {
      e.stopPropagation(); // never re-flip the card back to front
      var target = document.querySelector(cta.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: A.reducedMotion ? 'auto' : 'smooth', block: 'start' });
    });
  });

  if (A.reducedMotion) {
    var track = root.querySelector('.afd-marquee__track');
    if (track) track.style.animation = 'none';
  }
})();
